import React, { useState, useEffect, useContext } from 'react';

import { Dimensions, StyleSheet, TouchableHighlight, View } from 'react-native';
import UserAvatar from 'react-native-user-avatar';
import { SvgXml } from 'react-native-svg';
import DyteText from './DyteText';
import { Notification } from '../types/props';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  notification,
  onDyteNotificationDismiss,
  iconPack = defaultIconPack,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  size = 'sm',
  t,
}: {
  notification: Notification;
  onDyteNotificationDismiss?: any;
  iconPack?: IconPack;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  let width_container = 211;
  const [pos, setPos] = useState(-1 * width_container);
  const [vanish, setVanish] = useState(false);
  useEffect(() => {
    const interval = setInterval(() => {
      if (!vanish) {
        if (pos < 0) setPos(pos + 20);
        else {
          setPos(0);
          // if (notification.duration && notification.duration === 0)
          //   onDyteNotificationDismiss();
          setTimeout(() => {
            if (notification.duration && notification.duration !== 0) {
              setVanish(true);
            }
          }, notification.duration ?? 1500);
        }
      } else if (vanish && notification.duration !== undefined) {
        if (pos > -1 * width_container) setPos(pos - 20);
        else {
          if (notification.duration && notification.duration !== 0)
            onDyteNotificationDismiss();
          clearInterval(interval);
          setPos(-1 * width_container);
        }
      }
    }, 3);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pos, vanish]);
  const { width } = Dimensions.get('screen');

  const styles = StyleSheet.create({
    wrapper: {
      flexWrap: 'wrap',
      left: pos,
      maxWidth: width * 0.9,
    },
    notificationContainer: {
      backgroundColor: colors.background[800],
      flexDirection: 'row',
      height: 35,
      marginVertical: 2,
      borderRadius: 5,
      alignItems: 'center',
    },
    text: {
      flexWrap: 'wrap',
      maxWidth: Dimensions.get('screen').width * 0.5,
      marginLeft: 10,
      color: 'white',
    },
    closeButton: {
      marginLeft: 15,
      marginRight: 10,
      height: 16,
      width: 16,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 10,
    },
    userIcon: {
      height: 25,
      width: 25,
      marginLeft: 10,
    },
  });
  return (
    <View
      style={styles.wrapper}
      onLayout={(event) => {
        width_container = event.nativeEvent.layout.width;
      }}
    >
      <View style={[styles.notificationContainer]}>
        <View style={styles.userIcon}>
          <UserAvatar
            size={25}
            src={notification.image}
            name={'Dyte User'}
            bgColor={colors.brand[500]}
          />
        </View>
        <DyteText size="sm" style={styles.text}>
          {notification.message}
        </DyteText>
        <DyteText size="sm" style={styles.text}>
          {notification.button.text}
        </DyteText>
        <TouchableHighlight
          underlayColor={colors.background[800]}
          style={styles.closeButton}
          onPress={() => {
            onDyteNotificationDismiss();
            setVanish(true);
            notification.duration = 0;
          }}
        >
          <SvgXml
            xml={iconPack.dismiss.replace('currentColor', colors.text)}
            width={15}
            height={15}
          />
        </TouchableHighlight>
      </View>
    </View>
  );
}
